import * as React from "react";
import { themeController } from "./themeController";
import { ThemePreference } from "./persistence";
import { ThemeName } from "./palette";

export const useThemePreference = (): {
  preference: ThemePreference; effective: ThemeName; setPreference: (p: ThemePreference) => void;
} => {
  const [, force] = React.useReducer((n: number) => n + 1, 0);
  React.useEffect(() => themeController.subscribe(force), []);
  return {
    preference: themeController.getPreference(),
    effective: themeController.getEffective(),
    setPreference: themeController.setPreference,
  };
};
